/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';

/*
The login form's text input.

formsy-react 2 changed how withFormsy hands state to the wrapped component: v1 injected
getValue(), getErrorMessage(), isValid() and showError() as functions, v2 injects `value`,
`errorMessage`, `isValid` and `showError` as plain values. setValue is still a function.
Calling the old ones on v2 does not fail loudly - `isValid()` on a boolean throws, but
`showError()` inside a template string would just have blown up at render.

v2 also stopped exporting `propTypes`, so the types below are spelled out.
*/
class FormInputLogin extends Component {
  state = {
    internalValue: '',
  };

  // The input is controlled locally and only pushed into formsy on blur, so the local
  // copy has to follow when formsy's value changes underneath it - a form reset, for one.
  componentDidUpdate = (prevProps, prevState) => {
    const { value } = this.props;
    if (prevProps !== this.props && value !== undefined) {
      if (prevState.internalValue !== value) {
        this.setState({
          internalValue: value,
        });
      }
    }
  };

  changeValue = (e) => {
    this.setState({
      internalValue: e.currentTarget.value,
    });
  };

  validate = (e) => {
    const { setValue } = this.props;
    setValue(e.currentTarget.value);
  };

  render() {
    const { internalValue } = this.state;

    const {
      name, type, title, showError, errorMessage, isValid,
    } = this.props;

    return (
      <div className="w-full">
        <label className="flex flex-col font-americaMonoRegular text-xs uppercase" htmlFor={name}>
          {title}
          <input
            onChange={this.changeValue}
            onBlur={this.validate}
            name={name}
            type={type || 'text'}
            value={internalValue}
            autoComplete={name}
            className={`mt-2 rounded-full border-1 p-2 bg-white outline-none  ${showError ? 'border-red text-red' : 'border-black text-black'} ${isValid && internalValue !== '' ? 'border-green text-green' : 'border-black text-black'}`}
          />
        </label>
        {/*
          Gated on showError, which is what that prop is for. errorMessage is populated
          whenever the field is invalid, pristine or not, so rendering it bare put "The
          password is too short" under an empty password box before anyone had typed. That
          predates the formsy 2 upgrade - v1 rendered it ungated too - it is just very
          visible now that the login page is being looked at.

          showError is !showRequired() && !isValid(), and showRequired is true while a
          required field is empty, so the message stays hidden until there is something
          wrong with what was actually typed.
        */}
        <span className="flex flex-col text-red mt-4">{showError ? errorMessage : null}</span>
      </div>
    );
  }
}

FormInputLogin.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
  // Injected by withFormsy.
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  showError: PropTypes.bool,
  isValid: PropTypes.bool,
  errorMessage: PropTypes.node,
};

FormInputLogin.defaultProps = {
  title: '',
  type: 'text',
  value: '',
  showError: false,
  isValid: false,
  errorMessage: null,
};

export default withFormsy(FormInputLogin);
